import React from 'react';
import ImpressumC from '../components/Impressum/Impressum';
import NewsBanner from '../components/NewsBanner/News';

const Impressum = () => {
  return (
      <>
        <NewsBanner/>
        <ImpressumC/>
      </>
  )
}

export default Impressum